"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectCompetitorRenameConfig = exports.selectCompetitorsRenameDate = exports.selectIsDevelopment = exports.selectFeatureFlags = exports.selectApiConfiguration = exports.selectSseConfiguration = exports.selectApiBasePath = exports.selectConfigLoaded = exports.selectConfig = void 0;
const betweb_openapi_axios_1 = require("betweb-openapi-axios");
const reselect_1 = require("reselect");
const env_1 = require("../../utils/env");
const slice_1 = require("./slice");
const selectConfig = (state) => state.configProvider.config || slice_1.initialState.config;
exports.selectConfig = selectConfig;
const selectConfigLoaded = (state) => state.configProvider.configLoaded;
exports.selectConfigLoaded = selectConfigLoaded;
const selectApiBasePath = (state) => !(0, exports.selectConfig)(state).isDevelopment || !env_1.isBrowser
    ? (0, exports.selectConfig)(state).API_URL
    : '/api';
exports.selectApiBasePath = selectApiBasePath;
const selectSseConfiguration = (state, accountId) => {
    if (accountId) {
        return `${(0, exports.selectApiBasePath)(state)}/accounts/${accountId}/updates`;
    }
    return undefined;
};
exports.selectSseConfiguration = selectSseConfiguration;
const selectApiConfiguration = (state, params) => {
    const basePath = (0, exports.selectApiBasePath)(state);
    if (params === null || params === void 0 ? void 0 : params.private) {
        if (env_1.isReactNative) {
            const accessTokenRaw = state.storageProvider.storage.accessToken;
            const accessToken = !!accessTokenRaw && JSON.parse(accessTokenRaw);
            const authHeader = { Authorization: `Bearer ${accessToken}` };
            return new betweb_openapi_axios_1.Configuration({
                basePath,
                baseOptions: { headers: authHeader },
            });
        }
        else {
            return new betweb_openapi_axios_1.Configuration({
                basePath,
                baseOptions: { withCredentials: true },
            });
        }
    }
    else {
        return new betweb_openapi_axios_1.Configuration({ basePath });
    }
};
exports.selectApiConfiguration = selectApiConfiguration;
const selectFeatureFlags = (state) => {
    return (state.configProvider.config.FEATURE_FLAGS ||
        slice_1.initialState.config.FEATURE_FLAGS);
};
exports.selectFeatureFlags = selectFeatureFlags;
const selectIsDevelopment = (state) => { var _a; return (_a = state.configProvider.config.isDevelopment) !== null && _a !== void 0 ? _a : slice_1.initialState.config.isDevelopment; };
exports.selectIsDevelopment = selectIsDevelopment;
const selectCompetitorsRenameDate = (state) => {
    var _a;
    return (_a = state.configProvider.config.DATE_OF_SB_COMPETITORS_RENAME) !== null && _a !== void 0 ? _a : slice_1.initialState.config.DATE_OF_SB_COMPETITORS_RENAME;
};
exports.selectCompetitorsRenameDate = selectCompetitorsRenameDate;
exports.selectCompetitorRenameConfig = (0, reselect_1.createSelector)([(state) => state.configProvider.config], (config) => {
    var _a, _b, _c;
    return ({
        renameDate: (_a = config.DATE_OF_SB_COMPETITORS_RENAME) !== null && _a !== void 0 ? _a : slice_1.initialState.config.DATE_OF_SB_COMPETITORS_RENAME,
        isNewSbCompetitorsNameEnabled: (_c = (_b = config.FEATURE_FLAGS) === null || _b === void 0 ? void 0 : _b.NEW_SB_COMPETITORS_NAME_ENABLED) !== null && _c !== void 0 ? _c : false,
    });
});
//# sourceMappingURL=selectors.js.map